import React from "react";
import MaskedInput from "react-text-mask";
import { MASK_FONE } from "../../../helper/mask";

const InputTelefone = (props) => <MaskedInput mask={MASK_FONE} guide={false} {...props}  disabled={true}/>;

export default InputTelefone;